const regexYears = /(.Y$)|(.M$)|(.A$)/;
var aSizeOptionsByAge = [];
var listTranslatedOptions = [];

document.addEventListener('DOMContentLoaded', function () {
    reorderFilters();
});

function reorderFilters() {
    try {        
        loadSizeOptionsByAge();
        reorderSizeFilterWithAges();
        reorderProductTypeFilter();        
    } catch (e) {
        //console.error("reorderFilters error: "+ e.message);
        return true;
    }    
}

function loadSizeOptionsByAge() {
    if(aSizeOptionsByAge.length == 0) {
        let sizeOptions = document.querySelectorAll(".custom-size-filter input.mobile-facets__checkbox");
        let countSizeAge = 0;
        sizeOptions.forEach( function (element) {
            let hasYears = regexYears.test(element.value);
            if ( hasYears ) {
                aSizeOptionsByAge[element.value] = element;
                countSizeAge++;
            }         
        });
        aSizeOptionsByAge.length = countSizeAge;        
    }        
}

function reorderSizeFilterWithAges() {
    let filterList = document.querySelectorAll(".custom-size-filter ul.mobile-facets__list");
    let listSizeYears = Object.keys(aSizeOptionsByAge);
    let reverseOptionsByAge = listSizeYears.reverse();

    reverseOptionsByAge.forEach( function (element) {
        let filterSizeElement = aSizeOptionsByAge[element];
        let inputSizeElement = document.getElementById(filterSizeElement.id);
        let liOptionSize = inputSizeElement.parentNode.parentNode;
        filterList[0].prepend(liOptionSize);
    });

}

function reorderProductTypeFilter() {
    if(listTranslatedOptions.length == 0) {
        // This waiting time is needed becouse Shopify translations for filters is not loaded just when the document is ready
        setTimeout(() => {
            let typeOptions = document.querySelectorAll(".custom-product-type-filter input.mobile-facets__checkbox");
            let countSize = 0
            typeOptions.forEach( function (element) {
                if(element.parentNode.getElementsByClassName("filter-label").length > 0
                && element.parentNode.getElementsByClassName("filter-label")[0].childNodes.length > 0) {                    
                    let translation = element.parentNode.getElementsByClassName("filter-label")[0].childNodes[0];
                    listTranslatedOptions[translation.textContent.trim()] = element;     
                    countSize++;   
                }
            });
            listTranslatedOptions.length = countSize;
            sortProductTypeTranslations();
        }, 500);
    } else {
        sortProductTypeTranslations();
    }    
}

function sortProductTypeTranslations() {
    let filterListProductType = document.querySelectorAll(".custom-product-type-filter ul.mobile-facets__list");
    let listProductTypeTranslated = Object.keys(listTranslatedOptions);
    let sortedProductList = listProductTypeTranslated.sort().reverse();
    
    sortedProductList.forEach( function (element) {
        let filterProductTypeElement = listTranslatedOptions[element];
        let inputProductTypeElement = document.getElementById(filterProductTypeElement.id);
        let liProductType = inputProductTypeElement.parentNode.parentNode;
        filterListProductType[0].prepend(liProductType);
    });
}